import React, { useCallback, useEffect, useMemo, useState } from "react";
import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import DeleteModal from "../../Components/Common/DeleteModal";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row, Spinner,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import Loader from "../../Components/Common/Loader";
import Flatpickr from "react-flatpickr";
import { toast, ToastContainer } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  addNewStudent as onAddNewStudent,
  deleteStudent as onDeleteStudent,
  getStudents as onGetStudents,
  updateStudent as onUpdateStudent,
  importStudent as onImportStudent,
  approveExamReattempt as onApproveExamReattempt,
} from "../../slices/student/thunk";
import Swal from 'sweetalert2';

import { getCourses as onGetCourses } from '../../slices/course/thunk';

import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import AuthorizeForAction from "../../Routes/AuthorizeForAction";
import { api } from "../../config";

const Student = ({ studentScope = 'mcd' }) => {
  const isDeliveryStudents = studentScope === 'mcd';
  const reattemptPermission = isDeliveryStudents
    ? 'delivery-allow-reattempt'
    : 'student-allow-reattempt';
  const pageTitle = isDeliveryStudents ? 'Delivery Students' : 'Regular Students';
  const listTitle = isDeliveryStudents ? 'Delivery Students List' : 'Regular Students List';

  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [modal, setModal] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [translationModal, setTranslationModal] = useState(false);
  const [student, setStudent] = useState([]);
  const [lang, setLang] = useState([]);
  const [StudentTranslation, setStudentTranslation] = useState([]);
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [defualtTranslation, setdefualtTranslation] = useState("");
  const [courseData, setCourseData] = useState([]);

  const [transFullname, setTransFullname] = useState([]);
  const [StudentTransFullname, setStudentTransFullname] = useState([]);
  const [transLang, setTransLang] = useState("");
  const [transInstruction, setTransInstruction] = useState([]);
  const [StudentTransInstructions, setStudentTransInstruction] = useState([]);
  const [transVideoLink, setTransVideoLink] = useState([]);
  const [StudentTransVideoLinks, setStudentTransVideoLink] = useState([]);

  const [loading, setLoading] = useState(true);
  const [isloading, setIsloading] = useState(false);
  const [commonQ, setcommonQ] = useState(0);
  const [vidQ, setVidQ] = useState(0);
  const [studentAllData, setStudentAllData] = useState();

  const selectLayoutState = (state) => state.Student;
  const selectCourseState = (state) => state.Course;

  const StudentProperties = createSelector(selectLayoutState, (ecom) => ({
    students: ecom.students,
    isStudentSuccess: ecom.isStudentSuccess,
    isStudentCreated: ecom.isStudentCreated,
    isSaveLoading: ecom.isSaveLoading,
    error: ecom.error,


  }));
  // Inside your component
  const { students, isStudentSuccess, isStudentCreated, error, isSaveLoading } = useSelector(StudentProperties);


  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  const importToggle = useCallback(() => {
    setImportModal(!importModal);
  }, [importModal]);

  useEffect(() => {
    dispatch(onGetStudents(studentScope));
  }, [dispatch, studentScope]);

  useEffect(() => {
    if (isStudentCreated) {
      dispatch(onGetStudents(studentScope));
    }
  }, [dispatch, isStudentCreated, studentScope]);

  useEffect(() => {

    setStudent(students);
    setLoading(!isStudentSuccess);

    if (isStudentCreated) {
      setIsloading(false);
      validation.resetForm();
      importValidation.resetForm();
      setModal(false);
      setImportModal(false);
      setTranslationModal(false);
    }
    if (error) {
      setIsloading(false);
    }
  }, [students, isStudentCreated, error]);

  useEffect(() => {

    if (!isEmpty(students)) {
      setStudent(students);
      setIsEdit(false);
      setLoading(!isStudentSuccess);
    }
  }, [students, isStudentCreated]);

  const courseProperties = createSelector(
    selectCourseState,
    (data) => ({
      courses: data.courses,

    })
  );

  const { courses } = useSelector(courseProperties)
  useEffect(() => {
    if (courses && !courses.length) {
      dispatch(onGetCourses());
    }
  }, [dispatch, courses]);

  useEffect(() => {
    if (!courses) return;
    setCourseData(
      isDeliveryStudents
        ? courses.filter((c) => c.short_name === 'MCD')
        : courses.filter((c) => c.short_name !== 'MCD')
    );
  }, [courses, isDeliveryStudents]);

  const validation = useFormik({

    enableReinitialize: true,
    initialValues: {
      traffic_id: (isEdit ? student && student.traffic_id : "") || "",
      std_name: (isEdit ? student && student.std_name : "") || "",
      email: (isEdit ? student && student.email : "") || "",
      nationality: (isEdit ? student && student.nationality : "") || "",
      // examiner_id: (isEdit ? student && student.examiner_id : "") || "",
      course_code: (isEdit ? student && student.course_code : "") || "",
      status: (isEdit ? student && student.status : "") || "",

    },
    validationSchema: Yup.object({
      std_name: Yup.string().required("Please Enter Full Name"),
      traffic_id: Yup.string().required("Please Enter Traffic ID"),
      email: Yup.string().required("Please Enter Email").email("Invalid email format"),
      nationality: Yup.string().required("Please Enter Nationality"),
      // examiner_id: Yup.string().required("Please Enter Examiner ID"),
      course_code: Yup.string().required("Please Select Course"),
      status: Yup.string().required("Please Enter Your Status"),

    }),
    onSubmit: (values) => {
      setIsloading(true);
      if (isEdit) {
        const updateStudent = {
          id: student ? student.id : 0,
          std_name: values.std_name,
          traffic_id: values.traffic_id,
          email: values.email,
          nationality: values.nationality,
          // examiner_id: values.examiner_id,
          course_code: values.course_code,
          status: values.status,

        };
        dispatch(onUpdateStudent(updateStudent));
      } else {
        const newStudent = {
          std_name: values["std_name"],
          traffic_id: values["traffic_id"],
          email: values["email"],
          nationality: values["nationality"],
          // examiner_id: values["examiner_id"],
          course_code: values["course_code"],
          status: values["status"],

        };
        dispatch(onAddNewStudent(newStudent));
      }
    },
  });

  const importValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      import_file: null,
    },
    validationSchema: Yup.object({
      import_file: Yup.mixed().required("Please Select File"),
    }),
    onSubmit: (values) => {
      setIsloading(true);
      const formData = new FormData();
      formData.append("file", values.import_file);
      dispatch(onImportStudent(formData));
    },
  });

  const StudentStatus = [
    {
      options: [
        { label: "Select Status", value: "" },
        { label: "Active", value: "1" },
        { label: "In-Active", value: "2" },
      ],
    },
  ];
  
  const StudentCources = [
    {
      options: [
        { label: "Select Course", value: "" },
        ...(isDeliveryStudents
          ? [{ label: "MC Delivery", value: "MCD" }]
          : [
              { label: "LMV", value: "LMV" },
            ]),
      ],
    },
  ];

  const handleCustomerClick = useCallback(
    (arg) => {
      const myStudent = arg;
      setStudent({
        id: myStudent.id,
        traffic_id: myStudent.traffic_id,
        email: myStudent.email,
        std_name: myStudent.std_name,
        nationality: myStudent.nationality,
        // examiner_id: myStudent.examiner_id,
        course_code: myStudent.scope_course_code
          || (myStudent.active_course ? myStudent.active_course.course.short_name : ""),
        status: myStudent.is_eligible,
      });
      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".customerCheckBox");
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  const handleApproveReattempt = (studentData) => {
    Swal.fire({
      text: `Allow ${studentData.std_name} to reattempt the exam via self-registration?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#F1416C',
      cancelButtonColor: '#181C32',
      confirmButtonText: 'Yes, approve',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(onApproveExamReattempt({
          studentId: studentData.id,
          scope: studentScope,
          courseId: studentData.scope_course_id || null,
        }));
      }
    });
  };

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll(".customerCheckBox:checked");
    ele.length > 0
      ? setIsMultiDeleteButton(true)
      : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };

  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            className="form-check-input"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="customerCheckBox form-check-input"
              value={cellProps.row.original.id}
              onChange={() => deleteCheckbox()}
            />
          );
        },
        id: "#",
      },
      {
        Header: "Traffic ID",
        accessor: "traffic_id",
        filterable: false,
      },
      {
        Header: "Student Name",
        filterable: false,
        accessor: "std_name",


      },
      {
        Header: isDeliveryStudents ? "Course" : "Active Course",
        accessor: "scope_course_code",
        Cell: (cell) => {
          const row = cell.row.original;
          const courseCode = row.scope_course_code
            || row.active_course?.course?.short_name;
          if (!courseCode) {
            return <span className="badge text-uppercase bg-danger-subtle text-danger">No Course Assigned</span>;
          }
          return <span className="badge text-uppercase bg-success-subtle text-success">{courseCode}</span>;
        }
      },
      {
        Header: "Nationality",
        filterable: false,
        accessor: "nationality",

      },
      {
        Header: "Status",
        accessor: "is_eligible",
        Cell: (cell) => {
          switch (cell.value) {
            case '1':
              return (
                <span className="badge text-uppercase bg-success-subtle text-success">
                  {" "}
                  {cell.value == '1' ? "Active" : ""}{" "}
                </span>
              );
            case '2':
              return (
                <span className="badge text-uppercase bg-danger-subtle text-danger">
                  {" "}
                  {cell.value == '2' ? "In-Active" : ""}{" "}
                </span>
              );
            default:
              return (
                <span className="badge text-uppercase bg-info-subtle text-info">
                  {" "}
                  {cell.value == '2' ? "In-Active" : "Active"}{" "}
                </span>
              );
          }
        },
      },
      {
        Header: "Last Exam",
        accessor: "last_exam_status",
        Cell: (cell) => {
          const status = cell.value;
          if (status === 'pass') {
            return <span className="badge text-uppercase bg-success-subtle text-success">Pass</span>;
          }
          if (status === 'fail') {
            return <span className="badge text-uppercase bg-danger-subtle text-danger">Fail</span>;
          }
          return <span className="text-muted">—</span>;
        },
      },
      {
        Header: "Reattempt",
        accessor: "exam_reattempt_approved",
        Cell: (cellProps) => {
          const row = cellProps.row.original;
          if (row.exam_reattempt_approved === 1 || row.exam_reattempt_approved === '1') {
            return <span className="badge text-uppercase bg-info-subtle text-info">Approved</span>;
          }
          if (row.can_approve_reattempt) {
            return (
              <AuthorizeForAction requiredPermissions={[reattemptPermission]}>
                <Button
                  color="primary"
                  size="sm"
                  outline
                  onClick={() => handleApproveReattempt(row)}
                >
                  Allow Reattempt
                </Button>
              </AuthorizeForAction>
            );
          }
          return <span className="text-muted">—</span>;
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <AuthorizeForAction requiredPermissions={['student-edit']}>
                <li className="list-inline-item edit" title="Edit">
                  <Link
                    to="#"
                    className="text-primary d-inline-block edit-item-btn"
                    onClick={() => {
                      const customerData = cellProps.row.original;
                      handleCustomerClick(customerData);
                    }}
                  >
                    <i className="ri-pencil-fill fs-16"></i>
                  </Link>
                </li>
              </AuthorizeForAction>
              <AuthorizeForAction requiredPermissions={['student-delete']}>
                <li className="list-inline-item" title="Remove">
                  <Link
                    to="#"
                    className="text-danger d-inline-block remove-item-btn"
                    onClick={() => {
                      const customerData = cellProps.row.original;
                      onClickDelete(customerData);
                    }}
                  >
                    <i className="ri-delete-bin-5-fill fs-16"></i>
                  </Link>
                </li>
              </AuthorizeForAction>
            </ul>
          );
        },
      },
    ],
    [handleCustomerClick, checkedAll, reattemptPermission, isDeliveryStudents, handleApproveReattempt]
  );

  const onClickDelete = (student) => {
    setStudent(student);
    setDeleteModal(true);
  };

  const deleteMultiple = () => {
    const checkall = document.getElementById("checkBoxAll");
    selectedCheckBoxDelete.forEach((element) => {
      dispatch(onDeleteStudent(element.value));
      setTimeout(() => {
        toast.clearWaitingQueue();
      }, 3000);
    });
    setIsMultiDeleteButton(false);
    checkall.checked = false;
  };

  const handleCustomerClicks = () => {
    setStudent("");
    setIsEdit(false);
    toggle();
  };

  const handleDeleteCustomer = () => {
    if (student) {
      dispatch(onDeleteStudent(student.id));
      setDeleteModal(false);
    }
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const handleTabClick = (index) => {
    setActiveIndex(index);
  };

  document.title = `${pageTitle} | Theory Practice`;
  return (
    <React.Fragment>
      <div className="page-content">
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteCustomer}
          onCloseClick={() => setDeleteModal(false)}
        />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid>
          <BreadCrumb title={listTitle} pageTitle="Dashboard" />
          <Row>
            <Col lg={12}>
              <Card id="customerList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">{listTitle}</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div>
                        <AuthorizeForAction requiredPermissions={['student-delete']}>
                          {isMultiDeleteButton && (
                            <button
                              className="btn btn-soft-danger me-1"
                              onClick={() => setDeleteModalMulti(true)}
                            >
                              <i className="ri-delete-bin-2-line"></i>
                            </button>
                          )}
                        </AuthorizeForAction>
                        {isDeliveryStudents && (
                          <AuthorizeForAction requiredPermissions={['student-create']}>
                            <button
                              type="button"
                              className="btn btn-success add-btn"
                              id="create-btn"
                              onClick={() => {
                                setIsEdit(false);
                                toggle();
                              }}
                            >
                              <i className="ri-add-line align-bottom me-1"></i> Add
                              Student
                            </button>{" "}
                          </AuthorizeForAction>
                        )}
                        {isDeliveryStudents && (
                          <AuthorizeForAction requiredPermissions={['student-create']}>
                            <button
                              type="button"
                              className="btn btn-primary import-btn"
                              id="import-btn"
                              onClick={() => {
                                importToggle();
                              }}
                            >
                              <i className="ri-file-upload-line align-bottom me-1"></i> Import
                            </button>{" "}
                          </AuthorizeForAction>
                        )}
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className="card-body pt-0">
                  {(loading ?
                    <React.Fragment>
                      <div className="d-flex justify-content-center mx-2 mt-2">
                        <Spinner color="primary"> Loading... </Spinner>
                      </div>
                      {/*{toast.error(props.error, { position: "top-right", hideProgressBar: false, progress: undefined, toastId: "" })}*/}
                    </React.Fragment>
                    : <div>
                      {isStudentSuccess && students.length ? (
                        <TableContainer
                          columns={columns}
                          data={students || []}
                          isGlobalFilter={true}
                          isAddUserList={false}
                          customPageSize={10}
                          className="custom-header-css"
                          handleCustomerClick={handleCustomerClicks}
                          isCustomerFilter={false}
                          SearchPlaceholder="Search for Students, status or something..."
                        />
                      ) : (
                        <div className="py-4 text-center">
                          <div>
                            <lord-icon
                              src="https://cdn.lordicon.com/msoeawqm.json"
                              trigger="loop"
                              colors="primary:#405189,secondary:#0ab39c"
                              style={{ width: "72px", height: "72px" }}
                            ></lord-icon>
                          </div>

                          <div className="mt-4">
                            <h5>Sorry! No Record Found</h5>
                          </div>
                        </div>
                      )}
                    </div>)}

                  <Modal id="showModal" backdrop="static" isOpen={modal} toggle={toggle} centered>
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      {!!isEdit ? "Edit Student" : "Add Student"}
                    </ModalHeader>
                    <Form
                      className="tablelist-form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <input type="hidden" id="id-field" />

                        <div
                          className="mb-3"
                          id="modal-id"
                          style={{ display: "none" }}
                        >
                          <Label
                            htmlFor="id-field1"
                            className="form-label"
                          ></Label>
                          <Input
                            type="text"
                            id="id-field1"
                            className="form-control"
                            placeholder="ID"
                            readOnly
                          />
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="name-field" className="form-label">
                            Student Full Name
                          </Label>
                          <Input
                            name="std_name"
                            id="name-field"
                            className="form-control"
                            placeholder="Enter Student full name"
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.std_name || ""}
                            invalid={
                              validation.touched.std_name &&
                                validation.errors.std_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.std_name &&
                            validation.errors.std_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.std_name}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label
                            htmlFor="email_field"
                            className="form-label"
                          >
                            Email
                          </Label>
                          <Input
                            name="email"
                            type="text"
                            id="email_field"
                            placeholder="Enter Email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                                validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label
                            htmlFor="traffic_id_field"
                            className="form-label"
                          >
                            Traffic ID
                          </Label>
                          <Input
                            name="traffic_id"
                            type="text"
                            id="traffic_id_field"
                            placeholder="Enter Traffic ID"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.traffic_id || ""}
                            invalid={
                              validation.touched.traffic_id &&
                                validation.errors.traffic_id
                                ? true
                                : false
                            }
                          />
                          {validation.touched.traffic_id &&
                            validation.errors.traffic_id ? (
                            <FormFeedback type="invalid">
                              {validation.errors.traffic_id}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label
                            htmlFor="short_name_field"
                            className="form-label"
                          >
                            Nationality
                          </Label>
                          <Input
                            name="nationality"
                            type="text"
                            id="nationality_field"
                            placeholder="Enter Nationality"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.nationality || ""}
                            invalid={
                              validation.touched.nationality &&
                                validation.errors.nationality
                                ? true
                                : false
                            }
                          />
                          {validation.touched.nationality &&
                            validation.errors.nationality ? (
                            <FormFeedback type="invalid">
                              {validation.errors.nationality}
                            </FormFeedback>
                          ) : null}
                        </div>
                        {/* <div className="mb-3">
                          <Label
                            htmlFor="examiner_id_field"
                            className="form-label"
                          >
                            Examiner ID
                          </Label>
                          <Input
                            name="examiner_id"
                            type="text"
                            id="examiner_id_field"
                            placeholder="Enter Examiner ID"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.examiner_id || ""}
                            invalid={
                              validation.touched.examiner_id &&
                                validation.errors.examiner_id
                                ? true
                                : false
                            }
                          />
                          {validation.touched.examiner_id &&
                            validation.errors.examiner_id ? (
                            <FormFeedback type="invalid">
                              {validation.errors.examiner_id}
                            </FormFeedback>
                          ) : null}
                        </div> */}
                        <div className="mb-3">
                          <Label htmlFor="course-code-field" className="form-label">
                            Course
                          </Label>
                          <Input
                            name="course_code"
                            type="select"
                            className="form-select"
                            id="course-code-field"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.course_code || ""}
                            invalid={
                              validation.touched.course_code &&
                                validation.errors.course_code
                                ? true
                                : false
                            }
                          >
                            <React.Fragment>
                              <option value="">Select Course</option>
                              {courseData.map((item, key) => (
                                <option value={item.short_name} key={key}>
                                  {item.course_translation?.[0]?.full_name || item.short_name}
                                </option>
                              ))}
                            </React.Fragment>
                          </Input>
                          {validation.touched.course_code &&
                            validation.errors.course_code ? (
                            <FormFeedback type="invalid">
                              {validation.errors.course_code}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="status-field" className="form-label">
                            Status
                          </Label>
                          <Input
                            name="status"
                            type="select"
                            className="form-select"
                            id="status-field"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.status || ""}
                            invalid={
                              validation.touched.status &&
                                validation.errors.status
                                ? true
                                : false
                            }
                          >
                            {StudentStatus.map((item, key) => (
                              <React.Fragment key={key}>
                                {item.options.map((item, key) => (
                                  <option value={item.value} key={key}>
                                    {item.label}
                                  </option>
                                ))}
                              </React.Fragment>
                            ))}
                          </Input>
                          {validation.touched.status &&
                            validation.errors.status ? (
                            <FormFeedback type="invalid">
                              {validation.errors.status}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setModal(false);
                              validation.resetForm();
                            }}
                          >
                            {" "}
                            Close{" "}
                          </button>
                          <Button color="success" disabled={isloading ? true : false} className="btn-load" type="submit">
                            <span className="d-flex align-items-center">
                              {isloading ? <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner> : null}
                              <span className="flex-grow-1 ms-2">
                                {!!isEdit ? "Update" : "Add Student"}{" "}
                              </span>
                            </span>
                          </Button>

                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>

                  <Modal id="importModal" backdrop="static" isOpen={importModal} toggle={importToggle} centered>
                    <ModalHeader className="bg-light p-3" toggle={importToggle}>
                      Import Students
                    </ModalHeader>
                    <Form
                      className="tablelist-form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        importValidation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <div className="mb-3">
                          <Label htmlFor="import-file-field" className="form-label">
                            Select File (Excel/CSV)
                          </Label>
                          <Input
                            name="import_file"
                            id="import-file-field"
                            className="form-control"
                            type="file"
                            accept=".xlsx, .xls, .csv"
                            onChange={(event) => {
                              importValidation.setFieldValue("import_file", event.currentTarget.files[0]);
                            }}
                            onBlur={importValidation.handleBlur}
                            invalid={
                              importValidation.touched.import_file &&
                                importValidation.errors.import_file
                                ? true
                                : false
                            }
                          />
                          {importValidation.touched.import_file &&
                            importValidation.errors.import_file ? (
                            <FormFeedback type="invalid">
                              {importValidation.errors.import_file}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mt-2">
                          <a 
                            href={`${api.SAMPLE_URL}student_import_sample.csv`} 
                            download 
                            className="text-primary text-decoration-underline"
                          >
                            <i className="ri-file-download-line align-bottom me-1"></i> Download Sample File
                          </a>
                        </div>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setImportModal(false);
                              importValidation.resetForm();
                            }}
                          >
                            Close
                          </button>
                          <Button color="success" disabled={isloading ? true : false} className="btn-load" type="submit">
                            <span className="d-flex align-items-center">
                              {isloading ? <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner> : null}
                              <span className="flex-grow-1 ms-2">
                                Import Students
                              </span>
                            </span>
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>

                  <ToastContainer closeButton={false} limit={1} />

                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Student;
